/* eslint-disable */
/**
 * Generated by scripts/generate-pages-index.js - do not edit by hand.
 * Regenerated on every build, start and test from src/content/pages/.
 */

export interface CmsPageFile {
  /** URL segment, taken from the file name. */
  slug: string;
  /** Raw JSON as written by the CMS; mapped in adapters/secondary/content/. */
  data: unknown;
}

import page0_beispielseite from './pages/beispielseite.json';
import page1_ressourcen from './pages/ressourcen.json';
import page2_test_seite_dominik from './pages/test-seite-dominik.json';
import page3_was_ist_m_e from './pages/was-ist-m-e.json';

export const CMS_PAGE_FILES: CmsPageFile[] = [
  { slug: 'beispielseite', data: page0_beispielseite },
  { slug: 'ressourcen', data: page1_ressourcen },
  { slug: 'test-seite-dominik', data: page2_test_seite_dominik },
  { slug: 'was-ist-m-e', data: page3_was_ist_m_e },
];
